const countries = [
    { name: "Afghanistan", code: "+93", digits: 9 },
    { name: "Albania", code: "+355", digits: 9 },
    { name: "Algeria", code: "+213", digits: 9 },
    { name: "Andorra", code: "+376", digits: 6 },
    { name: "Angola", code: "+244", digits: 9 },
    { name: "Argentina", code: "+54", digits: 10 },
    { name: "Armenia", code: "+374", digits: 8 },
    { name: "Australia", code: "+61", digits: 9 },
    { name: "Austria", code: "+43", digits: 10 },
    { name: "Azerbaijan", code: "+994", digits: 9 },
    { name: "Bahrain", code: "+973", digits: 8 },
    { name: "Bangladesh", code: "+880", digits: 10 },
    { name: "Belarus", code: "+375", digits: 9 },
    { name: "Belgium", code: "+32", digits: 9 },
    { name: "Belize", code: "+501", digits: 7 },
    { name: "Benin", code: "+229", digits: 8 },
    { name: "Bhutan", code: "+975", digits: 8 },
    { name: "Bolivia", code: "+591", digits: 8 },
    { name: "Bosnia and Herzegovina", code: "+387", digits: 8 },
    { name: "Botswana", code: "+267", digits: 7 },
    { name: "Brazil", code: "+55", digits: 11 },
    { name: "Brunei", code: "+673", digits: 7 },
    { name: "Bulgaria", code: "+359", digits: 9 },
    { name: "Burundi", code: "+257", digits: 8 },
    { name: "Cambodia", code: "+855", digits: 9 },
    { name: "Cameroon", code: "+237", digits: 9 },
    { name: "Canada", code: "+1", digits: 10 },
    { name: "Chile", code: "+56", digits: 9 },
    { name: "China", code: "+86", digits: 11 },
    { name: "Colombia", code: "+57", digits: 10 },
    { name: "Costa Rica", code: "+506", digits: 8 },
    { name: "Croatia", code: "+385", digits: 9 },
    { name: "Cuba", code: "+53", digits: 8 },
    { name: "Cyprus", code: "+357", digits: 8 },
    { name: "Czech Republic", code: "+420", digits: 9 },
    { name: "Denmark", code: "+45", digits: 8 },
    { name: "Dominican Republic", code: "+1-809", digits: 10 },
    { name: "Ecuador", code: "+593", digits: 9 },
    { name: "Egypt", code: "+20", digits: 10 },
    { name: "El Salvador", code: "+503", digits: 8 },
    { name: "Estonia", code: "+372", digits: 8 },
    { name: "Ethiopia", code: "+251", digits: 9 },
    { name: "Fiji", code: "+679", digits: 7 },
    { name: "Finland", code: "+358", digits: 9 },
    { name: "France", code: "+33", digits: 9 },
    { name: "Germany", code: "+49", digits: 10 },
    { name: "Ghana", code: "+233", digits: 9 },
    { name: "Greece", code: "+30", digits: 10 },
    { name: "Guatemala", code: "+502", digits: 8 },
    { name: "Honduras", code: "+504", digits: 8 },
    { name: "Hong Kong", code: "+852", digits: 8 },
    { name: "Hungary", code: "+36", digits: 9 },
    { name: "Iceland", code: "+354", digits: 7 },
    { name: "India", code: "+91", digits: 10 },
    { name: "Indonesia", code: "+62", digits: 10 },
    { name: "Iran", code: "+98", digits: 10 },
    { name: "Iraq", code: "+964", digits: 10 },
    { name: "Ireland", code: "+353", digits: 9 },
    { name: "Israel", code: "+972", digits: 9 },
    { name: "Italy", code: "+39", digits: 10 },
    { name: "Jamaica", code: "+1-876", digits: 10 },
    { name: "Japan", code: "+81", digits: 10 },
    { name: "Jordan", code: "+962", digits: 9 },
    { name: "Kazakhstan", code: "+7", digits: 10 },
    { name: "Kenya", code: "+254", digits: 9 },
    { name: "Kuwait", code: "+965", digits: 8 },
    { name: "Latvia", code: "+371", digits: 8 },
    { name: "Lebanon", code: "+961", digits: 8 },
    { name: "Libya", code: "+218", digits: 9 },
    { name: "Lithuania", code: "+370", digits: 8 },
    { name: "Luxembourg", code: "+352", digits: 9 },
    { name: "Malaysia", code: "+60", digits: 9 },
    { name: "Maldives", code: "+960", digits: 7 },
    { name: "Malta", code: "+356", digits: 8 },
    { name: "Mexico", code: "+52", digits: 10 },
    { name: "Monaco", code: "+377", digits: 8 },
    { name: "Mongolia", code: "+976", digits: 8 },
    { name: "Morocco", code: "+212", digits: 9 },
    { name: "Nepal", code: "+977", digits: 10 },
    { name: "Netherlands", code: "+31", digits: 9 },
    { name: "New Zealand", code: "+64", digits: 9 },
    { name: "Nigeria", code: "+234", digits: 10 },
    { name: "North Korea", code: "+850", digits: 10 },
    { name: "Norway", code: "+47", digits: 8 },
    { name: "Oman", code: "+968", digits: 8 },
    { name: "Pakistan", code: "+92", digits: 10 },
    { name: "Palestine", code: "+970", digits: 9 },
    { name: "Panama", code: "+507", digits: 8 },
    { name: "Paraguay", code: "+595", digits: 9 },
    { name: "Peru", code: "+51", digits: 9 },
    { name: "Philippines", code: "+63", digits: 10 },
    { name: "Poland", code: "+48", digits: 9 },
    { name: "Portugal", code: "+351", digits: 9 },
    { name: "Qatar", code: "+974", digits: 8 },
    { name: "Russia", code: "+7", digits: 10 },
    { name: "Saudi Arabia", code: "+966", digits: 9 },
    { name: "Singapore", code: "+65", digits: 8 },
    { name: "South Africa", code: "+27", digits: 9 },
    { name: "South Korea", code: "+82", digits: 10 },
    { name: "Spain", code: "+34", digits: 9 },
    { name: "Sri Lanka", code: "+94", digits: 9 },
    { name: "Sweden", code: "+46", digits: 9 },
    { name: "Switzerland", code: "+41", digits: 9 },
    { name: "Syria", code: "+963", digits: 9 },
    { name: "Thailand", code: "+66", digits: 9 },
    { name: "Turkey", code: "+90", digits: 10 },
    { name: "Ukraine", code: "+380", digits: 9 },
    { name: "United Arab Emirates", code: "+971", digits: 9 },
    { name: "United Kingdom", code: "+44", digits: 10 },
    { name: "United States", code: "+1", digits: 10 },
    { name: "Vietnam", code: "+84", digits: 10 },
    { name: "Yemen", code: "+967", digits: 9 },
    { name: "Zimbabwe", code: "+263", digits: 9 },
  ];

  export default countries